import I18n from 'i18n-js';
import {
  maxLengthRule,
  phoneRule,
} from 'views/v2/new-booking-page/delivery-form/common';

export const addressDetailFormField = {
  savedPlaceLabel: {
    fieldName: 'label',
    makeRules: () => [
      maxLengthRule(45),
      {
        required: true,
        message: I18n.t(
          'phrase.geWebBulkUpload.express_web_bulk_upload_line_error_field_required_error',
        ),
      },
    ],
    placeholder:
      'phrase.savedPoi.express_web_savedpoi_body_address_label_prominence',
  },
  poi: {
    fieldName: 'poi',
    makeRules: () => [
      {
        required: true,
        message: I18n.t(
          'phrase.geWebBulkUpload.express_web_bulk_upload_line_error_field_required_error',
        ),
      },
    ],
    placeholder: I18n.t(
      'phrase.savedPoi.express_web_savedpoi_body_add_location_prominence',
    ),
  },
  addressDetail: {
    fieldName: 'address_details',
    makeRules: () => [maxLengthRule(120)],
    placeholder:
      'phrase.savedPoi.express_web_savedpoi_body_address_details_prominence',
  },
  locationNote: {
    fieldName: 'note_to_driver',
    makeRules: () => [maxLengthRule(120)],
    placeholder:
      'phrase.savedPoi.express_web_savedpoi_body_note_to_driver_prominence',
  },
  contactName: {
    fieldName: 'contact_name',
    makeRules: () => [maxLengthRule(50)],
    placeholder:
      'phrase.savedPoi.express_web_savedpoi_body_contact_name_prominence',
  },
  contactNumber: {
    fieldName: 'contact_number',
    makeRules: ({ minLength = 5, maxLength = 15 }) => [
      phoneRule(minLength, maxLength),
    ],
    placeholder:
      'phrase.savedPoi.express_web_savedpoi_body_contact_number_prominence',
  },
};

export default {};
